const { default: Carousel } = require("./components/slideshow");

function App() {
  return (
    <div className="App">
      <Carousel />
    </div>
  );
}

export default App;
